var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWcagLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3288 17.4375L20.0537 17.9835L17.3179 11.6979H10.9651V10.3861H17.0875V7.75042H10.9651V5.36818C11.8666 4.89226 12.4831 3.94642 12.4831 2.85802C12.4831 1.29298 11.2099 0.0200195 9.64512 0.0200195C8.08032 0.0200195 6.80688 1.29322 6.80688 2.85826C6.80688 3.94834 7.42561 4.89538 8.32945 5.37058V14.3336H15.5909L18.6828 21.4383L22.3663 19.8606L21.3288 17.4375Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8638 21.3847C6.66004 21.3847 4.0534 18.7783 4.0534 15.5745C4.0534 13.4066 5.24764 11.5135 7.01188 10.5148V7.625C3.75388 8.7974 1.41772 11.9176 1.41772 15.5745C1.41772 20.2312 5.2066 24.0204 9.8638 24.0204C12.7292 24.0204 15.2643 22.5847 16.7919 20.3956L15.4251 17.2548C14.7024 19.6418 12.4832 21.3847 9.8638 21.3847Z",
    fill: "#353535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcagLogo);
export default __webpack_public_path__ + "static/media/wcag-logo.1c002b20de382fea1fc6f21c68a78eec.svg";
export { ForwardRef as ReactComponent };